import { render, staticRenderFns } from "./CadastroMensagens.vue?vue&type=template&id=85a60224&"
import script from "./CadastroMensagens.vue?vue&type=script&lang=js&"
export * from "./CadastroMensagens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports